import {
  fetchDealerIntegrations,
  includeIntegrationToDealer,
  excludeIntegrationFromDealer,
} from "@/services/dealerIntegrations";
import { getVPCLocationById } from "@/services/nissanVPCLocations";

const Model = {
  namespace: "entityIntegrations",
  state: {
    integrations: {}, // object with keys as integration types and values as arrays of integrations items
  },
  effects: {
    *getDealerIntegrations({ dealerId }, { call, put, all }) {
      const response = yield call(fetchDealerIntegrations, dealerId);
      const integrationsWithDetails = yield all(
        response.map(integration =>
          call(function* anonymous() {
            const details = yield call(getVPCLocationById, integration.integrationId);
            return { ...integration, details };
          }),
        ),
      );

      // group all the integrations by type
      const integrationsByType = Object.groupBy(integrationsWithDetails, ({ type }) => type);

      yield put({
        type: "setDealerIntegrations",
        payload: integrationsByType,
      });
    },
    *addIntegrationToDealer({ dealerId, integrationType, integrationId }, { call, put }) {
      const response = yield call(includeIntegrationToDealer, dealerId, integrationType, integrationId);
      yield put({
        type: "addSingleIntegration",
        integration: response,
      });
    },
    *removeIntegrationFromDealer({ integrationId }, { call }) {
      try {
        yield call(excludeIntegrationFromDealer, integrationId);
        return true;
      } catch (error) {
        return false;
      }
    },
  },
  reducers: {
    setDealerIntegrations(state, { payload }) {
      return {
        ...state,
        integrations: payload,
      };
    },
    addSingleIntegration(state, { integration }) {
      const currentIntegrations = { ...state.integrations };
      currentIntegrations[integration.type] = [...(currentIntegrations[integration.type] || []), integration];

      return {
        ...state,
        integrations: currentIntegrations,
      };
    },
  },
};

export default Model;
